import './table.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import find from 'lodash/find';
import noop from 'lodash/noop';
import moment from 'moment';
import { getCurrencyIcon } from '../../../../../shared/js/get-currency-icon';
import SelectField from '../../shared/form-elements/select/field';
import Pagination from '../../shared/pagination';
import { Link } from 'react-router';

const Table = ({
	table,
	intl,
	sortByColumn,
	showMoreRows,
	toggleAutoArchiving,
	pagination,
	gotoPage,
	refererTypeOptions,
	updateRefererType,
	can
}) => (
	<div className="table-container campaigns-table">
		<table className="simple-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr>
					{table.headers.map((header, i) => (
						<th
							key={i}
							className={cn({
								'sort-header': header.direction,
								active: table.sortedColumn.index === header.index,
								[header.className]: header.className,
								[table.sortedColumn.direction]:
									table.sortedColumn.index === header.index && table.sortedColumn.direction
							})}
							onClick={() => (header.direction ? sortByColumn(header.index) : noop)}
						>
							{intl(header.title)}
						</th>
					))}
				</tr>
			</thead>

			<tbody className="simple-table__body">
				{table.rows.map((row, i) => (
					<tr key={i}>
						<td className="id">
							<span>{row.id}</span>
						</td>
						<td className="created-at">
							<span>{moment(row.created_at).format('DD.MM.YYYY')}</span>
						</td>
						<td className="currency">
							<span>{getCurrencyIcon(row.currency)}</span>
						</td>
						<td className="title">
							<span title={row.title}>{row.title}</span>
						</td>
						<td className="affiliate">
							<a href={`/affiliates/profile/${row.affiliate_id}`} target="_blank">
								{row.affiliate}
							</a>
						</td>
						<td className="offer">
							<a href={`/programs/editor/${row.offer_id}`} target="_blank">
								{row.offer}
							</a>
						</td>
						<td className="domains">
							{row.transit_domain && (
								<a href={`http://${row.transit_domain}`} target="_blank" className="transit-domain">
									<span>{row.transit_domain}</span>
								</a>
							)}
							<a href={`http://${row.landing_domain}`} target="_blank">
								<span>{row.landing_domain}</span>
							</a>
						</td>
						<td className="is_archived">
							<span>{row.is_archived.toString()}</span>
						</td>
						<td className="referer-type">
							<SelectField
								name="referer_type"
								placeholder="Referer type"
								searchable={false}
								clearable={true}
								value={getFromOptions(refererTypeOptions, row.referer_type)}
								options={refererTypeOptions}
								meta={{}}
								showLabel={false}
								onChange={val => updateRefererType(val, row.id)}
							/>
						</td>
						<td className="referer-type">
							{
								row.is_ignored_autoremove ?
									<button
										className="ui-btn ui-btn-primary apply autoarchive-btn"
										onClick={() => toggleAutoArchiving([row.id], false)}
									>
										{intl('Автоархивировать')}
									</button> :
									<button
										className="ui-btn ui-btn-primary apply autoarchive-btn"
										onClick={() => toggleAutoArchiving([row.id], true)}
									>
										{intl('Не автоархивировать')}
									</button>
							}
							{
								can('campaigns_edit') &&
								<Link className="action_edit" to={`campaigns/${row.id}/payout-editor`}></Link>
							}
						</td>
					</tr>
				))}
			</tbody>
		</table>
		<Pagination pagination={pagination} gotoPage={gotoPage} />
	</div>
);

Table.propTypes = {
	table: PropTypes.object,
	pagination: PropTypes.object,
	gotoPage: PropTypes.func,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	showMoreRows: PropTypes.func,
	updateRefererType: PropTypes.func,
	refererTypeOptions: PropTypes.array,
	can: PropTypes.func
};

export default Table;

const getFromOptions = (options, value) => {
	const val = find(options, { value });
	return val ? [val] : null;
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/campaigns/components/table.js